import { Link } from 'react-router-dom'
import { useNews } from '../hooks/useNews'
import { formatDate } from '../services/newsService'

const Announcements = () => {
  const { news, loading, error } = useNews(3)

  if (loading) {
    return (
      <section className="announcements">
        <div className="container">
          <h2 className="section-title">重要なお知らせ</h2>
          <p style={{ textAlign: 'center', color: '#666' }}>読み込み中...</p>
        </div>
      </section>
    )
  }

  if (error || news.length === 0) {
    return (
      <section className="announcements">
        <div className="container">
          <h2 className="section-title">重要なお知らせ</h2>
          <p style={{ textAlign: 'center', color: '#666' }}>
            現在お知らせはありません
          </p>
        </div>
      </section>
    )
  }

  return (
    <section className="announcements">
      <div className="container">
        <h2 className="section-title">重要なお知らせ</h2>
        <div className="announcement-list">
          {news.map((item) => (
            <div key={item.id} className="announcement-item">
              <span className="announcement-date">{formatDate(item.publishDate)}</span>
              <Link to={`/news/${item.id}`} className="announcement-link">
                {item.title}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Announcements

